import * as React from 'react';
import { Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import Route from '../../../../common/components/route';
import Container from '../../../../common/components/container';
import Overview from '../../../../common/components/overview';
import AdminsContainer from '../admins';
import RolesContainer from '../roles';
import * as userSelector from '../../../core/selectors/logged-user';
import { EPermissions } from '../../../../common/definitions';

const OrganisationPermissionsContainer = ({ match, history, permissions, t }) => (
  <Container name="SettingsAdmins">
    <Container.Content>
      <Overview>
        <Overview.Header>
          <Overview.Header.Filter
            active={match.path}
            onChange={(path) => history.push(path)}
            options={[
              permissions.indexOf(EPermissions.ORGANISATION_ORGANISATION_ADMINS_VIEW) > -1 && {
                label: t('organisation:settings_index_admins_title'),
                key: '/admin/admins',
              },
              permissions.indexOf(EPermissions.ORGANISATION_ROLES_VIEW) > -1 && {
                label: t('organisation:settings_index_roles_title'),
                key: '/admin/admins/roles',
              },
            ]}
          />
        </Overview.Header>
      </Overview>
      <Switch>
        {permissions.indexOf(EPermissions.ORGANISATION_ROLES_VIEW) > -1 && <Route path="/admin/admins/roles" component={RolesContainer} permission={{ name: EPermissions.ORGANISATION_ROLES_VIEW }} />}
        {permissions.indexOf(EPermissions.ORGANISATION_ORGANISATION_ADMINS_VIEW) > -1 && <Route exact path={['/admin/admins', '/admin/admins/:adminId']} component={AdminsContainer} />}
        {permissions.indexOf(EPermissions.ORGANISATION_ORGANISATION_ADMINS_VIEW) === -1 && <Redirect to="/admin/admins/roles" />}
      </Switch>
    </Container.Content>
  </Container>
);

const mapStateToProps = (state) => ({
  permissions: userSelector.permissions(state),
});

export default connect(mapStateToProps)(withTranslation()(OrganisationPermissionsContainer));
